import { DEFAULT_CHARACTER_ID } from "../engine/characterDefs";
import type { Game } from "../engine/game";
import { WeaponVisual } from "../engine/weaponVisual";
import type { PlayerBodyState } from "./playerSpriteConfig";

export interface PlayerVisualState {
	characterId: string;
	bodyState: PlayerBodyState;
	weaponVisual: WeaponVisual;
}

export function playerVisualStateKey(state: PlayerVisualState): string {
	return `${state.characterId}|${state.bodyState}|${state.weaponVisual}`;
}

export class PlayerVisualStateProvider {
	private readonly game: Game;
	private readonly isPlayerMoving: () => boolean;

	constructor(game: Game, isPlayerMoving: () => boolean = () => false) {
		this.game = game;
		this.isPlayerMoving = isPlayerMoving;
	}

	getState(): PlayerVisualState {
		return {
			characterId: this.game.characterId ?? DEFAULT_CHARACTER_ID,
			bodyState: this.isPlayerMoving() ? "walking" : "idle",
			weaponVisual: this.game.player?.getSelectedWeapon()?.getWeaponVisual() ?? WeaponVisual.NONE,
		};
	}

	getStateKey(): string {
		return playerVisualStateKey(this.getState());
	}
}
